import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";

export const useVincularAgendamentoVeiculo = () => {
  return useMutation({
    mutationFn: ({
      uuidAgendamento,
      uuidVeiculo,
    }: {
      uuidAgendamento: string;
      uuidVeiculo: string;
    }) => Agendamento.vincularAgendamentoAoVeiculo({ uuidAgendamento, uuidVeiculo }),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
